module.exports = __webpack_public_path__ + "img/ren.c6d0eb9a.png";